/**
 * File embedded-forms.js.
 *
 * JS code to remove the submit button on Gravity Forms with a class of 'first-tee--form-embed'
 *
 */

(function ($) {

    $( '.first-tee--form-embed .gform_footer' ).remove();

})(window.jQuery);
